<ng-container>
  <idp-header [collapsedHeader]="true" [fromApp]="'skyclub'"></idp-header>
  <div class="fresh-air content">
    <router-outlet></router-outlet>
  </div>

  <idp-footer></idp-footer>
</ng-container>
